(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name renewals.controller:RenewalsCtrl
     *
     * @description
     *
     */
    angular
        .module('renewals')
        .directive('focusOn',function($timeout) {
			return {
				restrict : 'A',
				link : function(vm,$element,$attr) {
					vm.$watch($attr.focusOn,function(_focusVal) {
						$timeout(function() {
							_focusVal ? $element[0].focus() : $element[0].blur();
						});
					});
				}
			}
		})
        .controller('RenewalsCtrl', RenewalsCtrl);

    function RenewalsCtrl(EventManagerService, MessageService, RenewalsService, PopupManager, applicationConstants,
                          CommonMasterData, CommonLogicService) {
        var vm = this;
        vm.ctrlName = 'RenewalsCtrl';

        vm.model = {
            searchOnGoing: false,
            searchPanelToggle: true,
            initialSearchDone: false,
            editorMode: applicationConstants.EDITOR_STATUS.ADD,
            searchCriteria: {
                crewBase: null,
                aircraftType: null,
                crewId: null,
                crewType: null,
                validationType: null,
                validation: null,
                dateOfIssue: CommonLogicService.getStartEndDateOfRelativeToMonth(null, 'NEXT', '0', 'START'),
                dateOfExpiry: CommonLogicService.getStartEndDateOfRelativeToMonth(null, 'NEXT', '0', 'END'),
                includeAcmiCrew: null,
                employerHub: null
            },
            masterList: {
                crewTypes: [],
                validationTypes: [],
                validations: [],
                fleetTypes: [],
                crewBases: [],
                crewList:[],
                acmiOptions: [
                  {value: 'No', label: 'No'},
                  {value: 'Yes', label: 'Yes'}
                ],
                employerHubs: []
            },
            gridDataList: [],
            selectedRow: null,
            isElasticLoadingVisible: false,
            totalNumberOfRecords:null

        };

      var dataObject = [];
      var hotSettings = [];
      var hot;

        EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);
        EventManagerService.registerEventListener(EventManagerService.EVENT.RENEWALS.ASSIGN_TRAINING, listUpdate);

        vm.clickOnSearch = function () {
            vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
            vm.model.initialSearchDone = false;
        };

        vm.changeEditorField = function (searchParams, flag) {
            switch (flag) {
                case "VALIDATION_TYPE":
                    searchValidations();
                    break;
                case "CREW_TYPE":
                	searchValidations();
                    loadCrewByType();
                    break;
                case "fromDate":
                	var tempFromDate = moment(searchParams.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
                	if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE") {
                		searchParams.toDate = tempFromDate;
                	}
                	break;
                default:
                    break;
            }
        };

        vm.searchByOptions = function (searchParams) {
            setDefault();
            vm.searchRenewals();


        };

        vm.searchRenewals = function () {
            vm.model.gridDataList = [];
            vm.model.searchCriteria.startPosition = 1;
            vm.model.initialSearchDone = true;
            searchRenewals();
        };

        vm.addRenewal = function () {
            vm.model.editorMode = applicationConstants.EDITOR_STATUS.ADD;
            vm.model.selectedRow = RenewalsService.getNewRenewal();
        };

        vm.selectAnExpiry = function (selectedExpiry) {
            selectedExpiry.crew = RenewalsService.getCrewByCrewId(vm.model.masterList.crewList, selectedExpiry.crewId);
            var params = RenewalsService.getScheduleTrainingByExpiry(selectedExpiry);
            RenewalsService.getAvailableTrainings(params,
                function (response) {
                    if(response.success && response.hasOwnProperty('scheduleTrainingSlots')){
                        var details = {};
                        details.trainingSchedules = response.scheduleTrainingSlots;
                        details.selectedExpiray = selectedExpiry;
                        if(details.trainingSchedules.length > 0){
                            details.title = 'Assign Available Trainings';
                            PopupManager.openModal('EXPIRY_TRAINING_ASSIGN_POPUP', details, confirmScheduleTrainingAssign);
                        }else{
                            MessageService.warning('No Schedule trainings');
                        }

                    }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        };

        function confirmScheduleTrainingAssign(pass) {

        }
        function listUpdate() {
            setDefault();
            vm.searchRenewals();
        }

        function searchRenewals() {
            showLoader(true);
            var searchParams = vm.model.searchCriteria;
            RenewalsService.searchGridData(
                searchParams,
                function (gridData, startPosition) {
                    updateGrid(gridData);
                    updateGridSearchStartPosition(startPosition);
                    vm.model.searchPanelToggle = false;
                    showLoader(false);
                    vm.model.searchOnGoing = false;
                },
                function (error) {
                    MessageService.error(error);
                    showLoader(false);
                }
            );
        }

        function loadCrewByType() {
            if(!!vm.model.searchCriteria.crewType){
                var params={};
                params.crewType = vm.model.searchCriteria.crewType.crewTypeCode;
                params.active = null;
                params.crewBase=null;
                params.fleetExperince=null;
                CommonMasterData.loadCrewList(params,
                    function (response) {
                        vm.model.masterList.crewList = RenewalsService.getAdaptedCrewList(response);
                    },
                    function () {
                        console.log('Crew list retrieval error');
                    }
                );
            }
        }

        function getNextSetOfRecords() {
            vm.model.isElasticLoadingVisible = true;
            if (!vm.model.searchOnGoing) {
                vm.model.searchOnGoing = true;
                searchRenewals();
            }
        }

        function setDefault() {
            vm.model.searchCriteria.pageSize = 100000;
            vm.model.searchCriteria.startPosition = 1;
            vm.addRenewal();
        }

        function updateGrid(gridData) {
            angular.forEach(gridData, function (row) {
                vm.model.gridDataList.push(row);
            });
            vm.model.isElasticLoadingVisible = false;
          vm.model.totalNumberOfRecords=vm.model.gridDataList.length;

          dataObject = vm.dataObject();
          hotSettings = vm.hotSettings();
          hot = new Handsontable(hotElement, hotSettings);
        }


      vm.dataObject = function () {
        var dataObject = [];

        for (var i in vm.model.gridDataList) {
          dataObject.push({
            ROW_NUMBER : parseInt(i)+1,
            CREW_ID: vm.model.gridDataList[i].crewId,
            CREW_NAME: vm.model.gridDataList[i].crewName,
            CREW_VALD: vm.model.gridDataList[i].validationType,
            CREW_EXP_DATE: vm.model.gridDataList[i].dateOfExpiry,
            CREW_BASE: vm.model.gridDataList[i].crewBase,
            CREW_AC_TYPE: vm.model.gridDataList[i].aircraftType,
            CREW_PLANNED_DATE: vm.model.gridDataList[i].plannedDate,
          })
        }
        return dataObject;
      };

      vm.hotSettings = function () {
        var hotSettings = {
          data: dataObject,
          undo: true,
          redo: true,
          copy: true,
          paste: true,
          copyRowsLimit: 1000000,

          columns: [
            {
              data: 'ROW_NUMBER',
              type: 'numeric',
              readOnly: true,
              manualColumnResize:13

            },
            {
              data: 'CREW_ID',
              type: 'text',
              readOnly: true
            },
            {
              data: 'CREW_NAME',
              type: 'text',
              readOnly: true
            },
            {
              data: 'CREW_VALD',
              type: 'text',
              readOnly: true
            },
            {
              data: 'CREW_EXP_DATE',
              type: 'text',
              readOnly: true
            },
            {
              data: 'CREW_BASE',
              type: 'text',
              readOnly: true
            },
            {
              data: 'CREW_AC_TYPE',
              type: 'text',
              readOnly: true
            },
            {
              data: 'CREW_PLANNED_DATE',
              type: 'text',
              readOnly: true
            }
          ],
          colWidths: [3, 4, 9, 4, 5, 4, 5, 5],
          stretchH: 'all',
          width: 1280,
          autoWrapRow: true,
          height: 760,
          rowHeaders: true,
          colHeaders: [
            '',
            'Crew ID',
            'Crew Name',
            'Validation',
            'Date of Expiry',
            'Base',
            'A/C Type                    ',
            'Planned Training Date'

          ],
          columnSorting: {
            indicator: true,
            sortEmptyCells: true,
            initialConfig: {
              column: 0,
              sortOrder: 'asc'
            }
          }
        };

        return hotSettings;
      };

      var hotElement = document.querySelector('#hot');

        function showLoader(flag) {
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
                flag: flag,
                target: 'renewals',
                animationName: 'crewing-loader'
            });
        }

        function updateGridSearchStartPosition(startPosition) {
            vm.model.searchCriteria.startPosition = startPosition;
        }

        function searchValidations() {

            vm.model.searchCriteria.validation = null;
            var crewTypeCode = null;

            if (vm.model.searchCriteria.validationType == null) {
                vm.model.masterList.validations = [];
                return;
            }

            if (!!vm.model.searchCriteria.crewType) {
            	crewTypeCode = vm.model.searchCriteria.crewType.crewTypeCode;
            }

            var postData = {validationType : vm.model.searchCriteria.validationType, crewTypeCode : crewTypeCode };

            RenewalsService.searchValidations(
            	postData,
                function (validations) {
                    vm.model.masterList.validations = validations;
                },
                function (error) {
                    MessageService.error(error);
                }
            );
        }


        RenewalsService.searchCrewTypes(
            function (crewTypes) {
                vm.model.masterList.crewTypes = crewTypes;
            },
            function (error) {
                MessageService.error(error);
            }
        );

        RenewalsService.searchValidationTypes(
            function (validationTypes) {
                vm.model.masterList.validationTypes = validationTypes;
            },
            function (error) {
                MessageService.error(error);
            }
        );

       CommonMasterData.getAircraftModelList(function(aircrafts) {
        vm.model.masterList.fleetTypes= aircrafts;
      }, function() {
        console.log('Aircraft types retrieval error');
      });

        RenewalsService.searchCrewBases(
            function (crewBases) {
                vm.model.masterList.crewBases = crewBases;
            },
            function (error) {
                MessageService.error(error);
            }
        );

        CommonMasterData.getEmployerHubList(
            function (employerHubs) {
                vm.model.masterList.employerHubs = employerHubs;
            },
            function (error) {
                MessageService.error(error);
            }
        );

        setDefault();

        vm.model.searchCriteria.includeAcmiCrew = vm.model.masterList.acmiOptions[0];

    }
}());
